import React from 'react'
import { ScheduleBaseDialog } from './base-dialog'
import { useUpdateScheduleMutation } from '@/hooks/api/use-schedule-query'
import { toast } from '@/components/ui/toaster'
import { ScheduleData, ScheduleFormData } from '../_utils/types'
import { extractTimeFromDateTime } from '../_utils/helper'
import { useTranslate } from '@tolgee/react'

type ScheduleEditDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  scheduleData: ScheduleData
}

export function ScheduleEditDialog(props: ScheduleEditDialogProps) {
  const { open, onOpenChange, scheduleData } = props
  const updateScheduleMutation = useUpdateScheduleMutation()
  const { t } = useTranslate()

  const onSubmit = async (values: ScheduleFormData) => {
    await updateScheduleMutation.mutateAsync({
      scheduleId: scheduleData?.id,
      updateData: {
        agentId: scheduleData?.agent_id,
        toolId: scheduleData?.tool_id,
        startDate: values.startDate,
        endDate: values?.endDate,
        startTime: values.startTime,
        frequency: values.frequency,
        parameters: values?.parameters,
      },
    })
    toast.success(t('schedule.dialogs.edit.toast.success'))
    onOpenChange(false)
  }

  return (
    <ScheduleBaseDialog
      open={open}
      onOpenChange={onOpenChange}
      handleSubmit={onSubmit}
      isSubmitting={updateScheduleMutation.isPending}
      title={t('schedule.dialogs.edit.title')}
      actionTitle={t('schedule.dialogs.edit.actionTitle')}
      initialValues={{
        agentId: scheduleData?.agent_id,
        toolId: scheduleData?.tool_id,
        startDate: scheduleData?.startDate,
        endDate: scheduleData?.endDate,
        parameters: scheduleData?.tool_args,
        startTime: extractTimeFromDateTime(scheduleData.startDate),
        frequency: scheduleData?.frequency,
      }}
    />
  )
}
